import actions from 'actions'
import _ from 'lodash'

const defaultState = {}

export default function draftEventGroup(state = defaultState, action) {
  const { type, eventGroup, data, eventGroupId } = action

  switch (type) {
    case actions.DRAFT_EVENTGROUP_CANCEL:
      return defaultState
    case actions.DRAFT_EVENTGROUP_EDIT:
      return _.merge({}, eventGroup)
    case actions.DRAFT_EVENTGROUP_UPDATE_FIELD:
      return (state.id === eventGroupId) ? Object.assign({}, state, data) : state
    default:
      return state
  }
}




/** WEBPACK FOOTER **
 ** ./src/reducers/draft/eventgroup/draft-eventgroup.js
 **/